import { render, staticRenderFns } from "./AccidentPartyForm.vue?vue&type=template&id=808eca7e"
import script from "./AccidentPartyForm.vue?vue&type=script&lang=js"
export * from "./AccidentPartyForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentPartyForm.vue?vue&type=style&index=0&id=808eca7e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports